// src/modules/app-views/_apps/applekkus/landingPages/pages/Init/components/tableColumns/templateColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function templateColumn(buildColumnProps, options = {}) {
  const {
    key = 'url',
    title = 'template',
    dataIndex = 'templateId',
    width = 150,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    className: 'text-truncate',
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => (
      <span>{r?.templateName || r?.templateId || '—'}</span>
    ),
  };
}

export default templateColumn;
